import React, { useContext } from 'react';
import LabelName from 'components/UI/LabelName/LabelName';

import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import { UserDetailsContext } from 'context/userDetailsContext';

import constants from 'constants/index';
import { useCalendarContext } from 'modules/calendar/Context/CalendarContext';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function BirthdayAndSOLPreview({ eventDetails }) {
  const userContext = useContext(UserDetailsContext);
  const { isClientCalendar } = useCalendarContext;

  let event_type = eventDetails?.extendedProps?.res_type;

  function navigateToModule(item, module) {
    if (!isClientCalendar) {
      if (module === 'cases' && !item.is_lead) {
        let case_id = item?.extendedProps?.case_id;
        return `/cases/${case_id}`;
      }
    }
  }

  return (
    <form>
      {/* form heading */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="modal-heading F-size16 text-bold">{event_type === 'user' ? 'Birthday' : 'SOL'}</div>
      </div>
      {/* title */}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12 ">
          <LabelName required={false} htmlFor="title">
            Event Title
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">{eventDetails?.title}</div>
      </div>
      {event_type === 'case' && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12">
            <LabelName required={false} htmlFor="title">
              Case
            </LabelName>
          </div>

          <div className="col-md-8 col-12 react-tagsinput-tag mb-2 casename-container p-2  text-center F-size13 m-0">
            {!isClientCalendar ? (
              <Link className="d-flex flex-grow-1 text-decoration-none text-reset" to={() => navigateToModule(eventDetails, 'cases')}>
                <span className="d-flex flex-grow-1 text-truncate">
                  {eventDetails?.extendedProps?.case_description.case_name ?? 'No case selected'}
                </span>
              </Link>
            ) : (
              <span className="pointer">{eventDetails?.extendedProps?.case_description.case_name ?? 'No case selected'}</span>
            )}
          </div>
        </div>
      )}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            Date
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">
          {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.start, constants.month_date_year_format)}
        </div>
      </div>
    </form>
  );
}

export default BirthdayAndSOLPreview;
